import { useState } from "react";
import { formatDateEntreeEnVigueur } from "../utils/legalGate";

// Bandeau de la FENÊTRE DE GRÂCE (#2377) — « nos conditions évoluent le … ».
//
// C'est le « message affiché dans l'application » que les CGU §12.2 promettent
// AVANT qu'une nouvelle version s'impose. Il ne bloque rien : l'utilisateur
// peut lire et accepter tout de suite (bouton) ou masquer le bandeau pour la
// session (×). À la date d'entrée en vigueur, le serveur cesse de dire
// `grace` et le mur bloquant prend le relais — c'est lui, pas ce bandeau, qui
// garantit l'acceptation.
const CLE_SESSION = "gively_grace_cgu_vue";

export default function LegalGraceBanner({ effectiveAt, isAssociation = false, onOpen }) {
  const [masque, setMasque] = useState(() => {
    try { return sessionStorage.getItem(CLE_SESSION) === "1"; } catch (_) { return false; }
  });
  if (masque) return null;
  const date = formatDateEntreeEnVigueur(effectiveAt);
  const fermer = () => {
    try { sessionStorage.setItem(CLE_SESSION, "1"); } catch (_) { /* navigation privée : on masque pour ce rendu */ }
    setMasque(true);
  };
  return (
    <div
      role="status"
      data-testid="legal-grace-banner"
      className="sticky top-0 z-40 bg-amber-50 border-b border-amber-200 text-amber-900 text-sm px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1"
    >
      <span className="flex-1 min-w-[12rem]">
        {isAssociation ? "Les conditions de votre association évoluent" : "Nos conditions évoluent"}
        {date ? ` le ${date}` : " prochainement"}. Jusque-là, rien ne change pour vous.
      </span>
      <button
        type="button"
        onClick={onOpen}
        data-testid="legal-grace-open"
        className="font-semibold text-[#1DA1F2] hover:underline"
      >
        Lire et accepter
      </button>
      <button
        type="button"
        onClick={fermer}
        aria-label="Masquer ce message"
        data-testid="legal-grace-dismiss"
        className="text-amber-700 hover:text-amber-900 px-1 text-base leading-none"
      >
        ×
      </button>
    </div>
  );
}
